import React, { useEffect, useState } from 'react';
import { withCreds } from '../authService';
import { CelestialShell, PageHeader, SystemFooter } from './ui/CelestialShell';

export default function AdminAuditLog() {
  const [logEntries, setLogEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchAuditLog() {
      try {
        const res = await withCreds('/api/audit-log', { method: 'GET' });
        const data = await res.json().catch(() => ({}));

        if (res.ok) setLogEntries(Array.isArray(data.log) ? data.log : []);
        else setError(data.error || 'Failed to load audit log.');
      } catch (err) {
        setError('Failed to fetch audit log.');
      } finally {
        setLoading(false);
      }
    }
    fetchAuditLog();
  }, []);

  return (
    <CelestialShell authenticated>
      <main className="br-container br-container--narrow">
        <PageHeader
          eyebrow="System stewardship"
          title="Audit log"
          description="A private, chronological record of internal corrections and preference enforcement. This surface is intentionally factual and restrained."
          aside={<span className="br-audit-count">{loading ? 'Synchronizing' : `${logEntries.length} ${logEntries.length === 1 ? 'entry' : 'entries'}`}</span>}
        />

        <section className="br-panel br-glass br-section" aria-live="polite">
          {loading && (
            <div className="br-inline-state">
              <span className="br-inline-state__pulse" aria-hidden="true" />
              <p>Aligning the private record...</p>
            </div>
          )}

          {!loading && error && <p className="br-status br-status--error">{error}</p>}

          {!loading && !error && logEntries.length === 0 && (
            <div className="br-inline-state br-inline-state--quiet">
              <span className="br-inline-state__pulse" aria-hidden="true" />
              <h2>The record is quiet.</h2>
              <p>No audit entries have been created yet.</p>
            </div>
          )}

          {!loading && !error && logEntries.length > 0 && (
            <ol className="br-audit-list" aria-label="Audit entries">
              {logEntries.map((entry, index) => (
                <li key={`${index}-${String(entry).slice(0, 24)}`} className="br-audit-entry">
                  <span className="br-audit-entry__index">{String(index + 1).padStart(2, '0')}</span>
                  <p>{String(entry || '').trim()}</p>
                </li>
              ))}
            </ol>
          )}
        </section>
        <SystemFooter />
      </main>
    </CelestialShell>
  );
}
